<template>
  <div class="card border-top-start-radius-0 border-top-end-radius-0 p-3" data-animation="FadeIn">
    <h5>{{ t('basicData') }}</h5>
    <!-- Dados básicos -->
    <div class="my-3 row">
      <div class="form-group col-12 col-sm-4">
        <label class="required">{{ t('studentName') }}</label>
        <!-- Nome do aluno -->
        <input
          class="form-control"
          type="text"
          :placeholder="t('studentName')"
          v-model="state.student.name"
        />
        <span class="ms-3 text-error text-danger" v-if="v$.student.name.$error">
          {{ v$.student.name.$errors[0].$message }}
        </span>
      </div>
      <div class="form-group col-12 col-sm-4">
        <label class="required">{{ t('studentSurname') }}</label>
        <!-- Sobrenome do aluno -->
        <input
          class="form-control"
          type="text"
          :placeholder="t('studentSurname')"
          v-model="state.student.surname"
        />
        <span class="ms-3 text-error text-danger" v-if="v$.student.surname.$error">
          {{ v$.student.surname.$errors[0].$message }}
        </span>
      </div>
      <div class="form-group col-12 col-sm-4 mt-sm-0">
        <label>{{ t('cpf') }}</label>
        <!-- CPF -->
        <input
          class="form-control"
          type="text"
          v-maska="'###.###.###-##'"
          :placeholder="t('cpfPlaceholder')"
          v-model="state.student.cpf"
        />
      </div>
      <div class="form-group col-12 col-sm-4 mt-sm-0">
        <label>{{ t('birthDate') }}</label>
        <!-- Data de nascimento -->
        <input
          class="form-control"
          type="text"
          v-maska="'##/##/####'"
          :placeholder="t('birthDatePlaceholder')"
          v-model="state.student.birth_date"
        />
      </div>
      <div class="form-group col-12 col-sm-4 mt-sm-0">
        <label class="required">{{ t('biologicalSex') }}</label>
        <!-- Sexo biológico -->
        <select
          class="form-control custom-select"
          name="sexo"
          required
          id="select-sexo"
          v-model="state.student.sex"
        >
          <option value="">{{ t('selectOption') }}</option>
          <!-- Selecione uma opção -->
          <option value="F">{{ t('female') }}</option>
          <!-- Feminino -->
          <option value="M">{{ t('male') }}</option>
          <!-- Masculino -->
        </select>
        <span class="ms-3 text-error text-danger" v-if="v$.student.sex.$error">
          {{ v$.student.sex.$errors[0].$message }}
        </span>
      </div>
      <div class="form-group col-12 col-sm-4 mt-sm-0">
        <label class="required">{{ t('height') }} ({{ state.heightUnit }})</label>
        <!-- Altura -->
        <input
          required
          class="form-control"
          type="text"
          :key="state.heightUnit"
          v-maska="state.heightUnit === 'm' ? '#,##' : '##.##'"
          v-model="state.student.height"
          :placeholder="state.heightUnit === 'm' ? '9,99' : '99.99'"
        />
        <span class="ms-3 text-error text-danger" v-if="v$.student.height.$error">
          {{ v$.student.height.$errors[0].$message }}
        </span>
      </div>
      <div class="form-group col-12 col-sm-4 mt-sm-0 flex">
        <label class="required">{{ t('weight') }} ({{ state.weightUnit }})</label>
        <!-- Peso -->
        <div class="input-group">
          <money3
            v-bind="state.weightConfig"
            v-model="state.student.weight"
            class="form-control"
          ></money3>
        </div>
        <span class="ms-3 text-error text-danger" v-if="v$.student.weight.$error">
          {{ v$.student.weight.$errors[0].$message }}
        </span>
      </div>
      <div class="form-group col-12 col-sm-4 mt-sm-0">
        <label class="required">{{ t('emailPlaceholder') }}</label>
        <!-- Email -->
        <input
          class="form-control"
          type="email"
          v-model="state.student.email"
          :placeholder="t('emailPlaceholder')"
        />
      </div>
      <div class="form-group col-12 col-sm-4 mt-sm-0">
        <label class="required">{{ t('accessPassword') }}</label>
        <!-- Senha de acesso -->
        <input
          class="form-control"
          type="password"
          v-model="state.student.password"
          :placeholder="t('passwordPlaceholder')"
        />
      </div>
      <div class="form-group col-12 col-sm-4 mt-sm-0">
        <label class="required">{{ t('cellPhone') }}</label>
        <!-- Celular -->
        <input
          class="form-control"
          type="text"
          v-maska="'(##) #####-####'"
          v-model="state.student.phone"
          :placeholder="t('phonePlaceholder')"
        />
        <span class="ms-3 text-error text-danger" v-if="v$.student.phone.$error">
          {{ v$.student.phone.$errors[0].$message }}
        </span>
      </div>
    </div>

    <!-- ENDERECO -->
    <hr />
    <h5>{{ t('address') }}</h5>
    <!-- Endereço -->
    <div class="my-3 row">
      <div class="form-group col-12 col-md-4">
        <label>{{ t('zipCode') }}</label>
        <!-- CEP -->
        <input
          class="form-control"
          type="text"
          v-maska="'#####-####'"
          :placeholder="t('zipCodePlaceholder')"
          v-model="state.cep"
        />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>{{ t('street') }}</label>
        <!-- Logradouro -->
        <input
          class="form-control"
          type="text"
          :placeholder="t('streetPlaceholder')"
          disabled
          v-model="state.student.street"
        />
      </div>
      <div class="form-group col-12 col-md-2">
        <label>{{ t('number') }}</label>
        <!-- Número -->
        <input
          class="form-control"
          type="text"
          ref="inputNumero"
          :placeholder="t('numberPlaceholder')"
          v-model="state.student.number"
        />
      </div>
      <div class="form-group col-12 col-md-2">
        <label>{{ t('complement') }}</label>
        <!-- Complemento -->
        <input
          class="form-control"
          type="text"
          :placeholder="t('complementPlaceholder')"
          v-model="state.student.complement"
        />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>{{ t('neighborhood') }}</label>
        <!-- Bairro -->
        <input
          class="form-control"
          type="text"
          :placeholder="t('neighborhoodPlaceholder')"
          disabled
          v-model="state.student.neighborhood"
        />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>{{ t('city') }}</label>
        <!-- Cidade -->
        <input
          class="form-control"
          type="text"
          :placeholder="t('cityPlaceholder')"
          disabled
          v-model="state.student.city"
        />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>{{ t('state') }}</label>
        <!-- Estado -->
        <input
          class="form-control"
          type="text"
          :placeholder="t('statePlaceholder')"
          disabled
          v-model="state.student.state"
        />
      </div>
    </div>

    <hr />
    <h5>{{ t('payment') }}</h5>
    <!-- Pagamento -->
    <div class="row">
      <div class="form-group col-12 col-md-4">
        <label class="required">{{ t('paymentCondition') }}</label>
        <!-- Condição de pagamento -->
        <select
          class="form-control custom-select"
          name="payment_condition"
          required
          id="select-payment_condition"
          v-model="state.student.payment_condition_id"
        >
          <option v-for="(item, index) in state.condicoesPagamento" :key="index" :value="item.id">
            {{ item.name }}
          </option>
        </select>
        <span class="ms-3 text-error text-danger" v-if="v$.student.payment_condition_id.$error">
          {{ v$.student.payment_condition_id.$errors[0].$message }}
        </span>
      </div>
      <div class="form-group col-12 col-sm-4 mt-sm-0" v-if="isMensalPorAula">
        <label class="required">Quantidade de aulas/mês</label>
        <select
          class="form-control custom-select"
          v-model="state.student.quantidade_aulas_mes"
          required
          @change="onQuantidadeAulasChange"
        >
          <option value="" disabled>Selecione</option>
          <option v-for="qtd in opcoesAulasMes" :key="qtd" :value="qtd">
            {{ qtd}} aulas/mês
          </option>
        </select>
        <span class="ms-3 text-error text-danger" v-if="v$.student.quantidade_aulas_mes?.$error">
          {{ v$.student.quantidade_aulas_mes?.$errors[0]?.$message }}
        </span>
      </div>
      <div class="form-group col-12 col-sm-4 mt-sm-0" v-if="isPorAula">
        <label class="required">Preço por aula (R$)</label>
        <div class="input-group">
          <money3
            v-bind="state.priceConfig"
            v-model="state.student.price_per_class"
            class="form-control"
          ></money3>
        </div>
        <span class="ms-3 text-error text-danger" v-if="v$.student.price_per_class?.$error">
          {{ v$.student.price_per_class?.$errors[0]?.$message }}
        </span>
      </div>
      <div class="form-group col-12 col-sm-4 mt-sm-0" v-if="isConsultoria">
        <label class="required">Valor da Consultoria (R$)</label>
        <div class="input-group">
          <money3
            v-bind="state.priceConfig"
            v-model="state.student.consulting_price"
            class="form-control"
          ></money3>
        </div>
        <span class="ms-3 text-error text-danger" v-if="v$.student.consulting_price?.$error">
          {{ v$.student.consulting_price?.$errors[0]?.$message }}
        </span>
      </div>
      <!-- Dias de treino - aparece quando seleciona quantidade de aulas -->
      <div class="form-group col-12 mt-3" v-if="isMensalPorAula && state.student.quantidade_aulas_mes">
        <label class="required mb-2">Dias de treino (selecione {{ diasNecessarios }} {{ diasNecessarios === 1 ? 'dia' : 'dias' }})</label>
        <div class="training-days-container">
          <div
            v-for="dia in diasSemana"
            :key="dia.value"
            class="training-day-checkbox"
            :class="{
              'selected': state.student.training_days && state.student.training_days.includes(dia.value),
              'disabled': state.student.training_days && !state.student.training_days.includes(dia.value) && state.student.training_days.length >= diasNecessarios
            }"
            @click="toggleTrainingDay(dia.value)"
          >
            <span class="day-abbrev">{{ dia.abbrev }}</span>
          </div>
        </div>
        <div class="mt-2">
          <small class="text-muted">
            Selecionados: {{ state.student.training_days ? state.student.training_days.length : 0 }} de {{ diasNecessarios }}
          </small>
          <span class="ms-3 text-error text-danger" v-if="!state.student.training_days || state.student.training_days.length !== diasNecessarios">
            <small>Selecione exatamente {{ diasNecessarios }} {{ diasNecessarios === 1 ? 'dia' : 'dias' }}</small>
          </span>
        </div>
      </div>
      <div class="form-group col-12 col-md-4">
        <label class="required">{{ t('paymentMethod') }}</label>
        <!-- Forma de pagamento -->
        <select
          class="form-control custom-select"
          name="payment_form"
          required
          id="select-payment_form"
          v-model="state.student.payment_form_id"
        >
          <option v-for="(item, index) in state.formasPagamento" :key="index" :value="item.id">
            {{ item.name }}
          </option>
        </select>
        <span class="ms-3 text-error text-danger" v-if="v$.student.payment_form_id.$error">
          {{ v$.student.payment_form_id.$errors[0].$message }}
        </span>
      </div>
      <div class="form-group col-12 col-md-4">
        <label class="required">{{ t('paymentDay') }}</label>
        <!-- Dia de pagamento -->
        <select
          class="form-control custom-select"
          name="payment_day"
          required
          id="select-payment_day"
          v-model="state.student.payment_day"
        >
          <option v-for="number in 31" :key="number" :value="number">{{ number }}</option>
        </select>
        <span class="ms-3 text-error text-danger" v-if="v$.student.payment_day.$error">
          {{ v$.student.payment_day.$errors[0].$message }}
        </span>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12 text-end">
        <router-link to="/alunos">
          <button type="button" class="btn bg-gradient-secondary">{{ t('close') }}</button>
          <!-- Fechar -->
        </router-link>
        <button type="button" class="ms-3 btn bg-gradient-primary" @click.prevent="salvar">
          {{ t('save') }}
          <!-- Salvar -->
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { GetAddress } from './../../../../services/cep.service'
import alunoRepository from '../../../../services/api/alunoRepository'
import formaPagamentoRepository from '../../../../services/api/formaPagamentoRepository'
import condicaoPagamentoRepository from '../../../../services/api/condicaoPagamentoRepository'
import { reactive, onMounted, ref, inject, watch, computed } from 'vue'
import useVuelidate from '@vuelidate/core'
import { required, helpers, requiredIf } from '@vuelidate/validators'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { Money3Component } from 'v-money3'

export default {
  components: {
    money3: Money3Component,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const swal = inject('$swal')
    const store = useStore()
    const { t } = useI18n()

    onMounted(() => {
      store.commit('SET_SPLASH_SCREEN', false)

      buscarCondicaoFormaPagamento()
      if (route.params.id && parseInt(route.params.id) > 0) {
        state.alunoId = parseInt(route.params.id)

        buscarDadosAluno()
      }
    })

    // 1. Defina o state ANTES de qualquer uso dele!
    const state = reactive({
      cep: '',
      student: {
        name: '',
        surname: '',
        cpf: '',
        birth_date: '',
        sex: '',
        height: '',
        weight: '',
        email: '',
        phone: '',
        cep: '',
        street: '',
        complement: '',
        number: '',
        neighborhood: '',
        city: '',
        state: '',
        payment_condition_id: '',
        payment_form_id: '',
        payment_day: '',
        password: '',
        active: true,
        quantidade_aulas_mes: '', // novo campo
        price_per_class: 0, // preço por aula
        consulting_price: 0, // valor da consultoria
        training_days: [], // dias de treino selecionados
      },
      alunoId: 0,
      formasPagamento: [],
      condicoesPagamento: [],
      weightUnit: store.state.weightUnit,
      heightUnit: store.state.heightUnit,
      weightConfig: {
        masked: false,
        prefix: '',
        suffix: '',
        thousands: '.',
        decimal: ',',
        precision: 2,
        disableNegative: true,
        disabled: false,
        min: 0,
        max: null,
        allowBlank: false,
        minimumNumberOfCharacters: 0,
        shouldRound: true,
        focusOnRight: false,
      },
      priceConfig: {
        masked: false,
        prefix: 'R$ ',
        suffix: '',
        thousands: '.',
        decimal: ',',
        precision: 2,
        disableNegative: true,
        disabled: false,
        min: 0,
        max: null,
        allowBlank: false,
        minimumNumberOfCharacters: 0,
        shouldRound: true,
        focusOnRight: false,
      },
    })

    // 2. Agora pode usar state normalmente nos computeds, watchers, etc.
    const opcoesAulasMes = [4, 8, 12, 16, 20]
    const diasDoMes = Array.from({ length: 31 }, (_, i) => i + 1)

    // Dias da semana para os checkboxes
    const diasSemana = [
      { value: 'dom', label: 'Domingo', abbrev: 'Dom' },
      { value: 'seg', label: 'Segunda', abbrev: 'Seg' },
      { value: 'ter', label: 'Terça', abbrev: 'Ter' },
      { value: 'qua', label: 'Quarta', abbrev: 'Qua' },
      { value: 'qui', label: 'Quinta', abbrev: 'Qui' },
      { value: 'sex', label: 'Sexta', abbrev: 'Sex' },
      { value: 'sab', label: 'Sábado', abbrev: 'Sáb' },
    ]

    // Calcula quantos dias de treino são necessários baseado na quantidade de aulas
    const diasNecessarios = computed(() => {
      const qtd = state.student.quantidade_aulas_mes
      if (!qtd) return 0
      return qtd / 4 // 4 aulas = 1 dia, 8 aulas = 2 dias, 12 aulas = 3 dias, etc.
    })

    // Limpa os dias selecionados quando muda a quantidade de aulas
    const onQuantidadeAulasChange = () => {
      state.student.training_days = []
    }

    // Toggle para selecionar/desselecionar dia de treino
    const toggleTrainingDay = (dayValue) => {
      // Garantir que training_days seja sempre um array
      if (!Array.isArray(state.student.training_days)) {
        state.student.training_days = []
      }

      const index = state.student.training_days.indexOf(dayValue)
      if (index > -1) {
        // Já está selecionado, remove
        state.student.training_days.splice(index, 1)
      } else {
        // Não está selecionado, adiciona (se não atingiu o limite)
        if (state.student.training_days.length < diasNecessarios.value) {
          state.student.training_days.push(dayValue)
        }
      }
    }
    const isMensal = computed(() => {
      const cond = state.condicoesPagamento.find(
        c => c.id === state.student.payment_condition_id
      )
      // Considera "mensal" tanto "Mensal Por Aula" quanto "Mês Corrente"
      return cond && cond.name && (cond.name.toLowerCase().includes('mensal') || cond.name.toLowerCase().includes('mês'))
    })

    const isMensalPorAula = computed(() => {
      const cond = state.condicoesPagamento.find(
        c => c.id === state.student.payment_condition_id
      )
      // Apenas "Mensal Por Aula" requer quantidade de aulas
      return cond && cond.name && cond.name.toLowerCase().includes('mensal por aula')
    })

    const isPorAula = computed(() => {
      const cond = state.condicoesPagamento.find(
        c => c.id === state.student.payment_condition_id
      )
      // "Por Aula" - cobra por aula avulsa
      return cond && cond.name && cond.name.toLowerCase() === 'por aula'
    })

    const isConsultoria = computed(() => {
      const cond = state.condicoesPagamento.find(
        c => c.id === state.student.payment_condition_id
      )
      // "Consultoria" - cobra valor de consultoria
      return cond && cond.name && cond.name.toLowerCase().includes('consultoria')
    })

    const inputNumero = ref(null)

    watch(
      () => state.cep,
      () => {
        if (state.cep && state.cep !== null && state.cep.length == 9) {
          buscaCep()
        }
      },
    )

    const buscaCep = () => {
      GetAddress(state.cep).then((endereco) => {
        state.student.cep = state.cep
        state.student.street = endereco.logradouro
        state.student.neighborhood = endereco.bairro
        state.student.city = endereco.cidade
        state.student.state = endereco.estado
        inputNumero.value.focus()
        // resolve, mas nao deveria precisar
        //this.$forceUpdate()
      })
    }

    const buscarCondicaoFormaPagamento = async () => {
      store.commit('SET_SPLASH_SCREEN', true)
      try {
        store.commit('SET_SPLASH_SCREEN', true)
        // let response = await formaPagamentoRepository.FormaGet().then(response => {
        //   store.commit('SET_SPLASH_SCREEN', false)
        //   console.log(response.data)
        //   if (response.data.success) {
        //     state.formasPagamento = response.data.data
        //   }
        // })
        let response = await formaPagamentoRepository.FormaGet()

        if (response.data.success) {
          state.formasPagamento = response.data.data
        }

        let response1 = await condicaoPagamentoRepository.CondicaoGet()

        if (response1.data.success) {
          state.condicoesPagamento = response1.data.data
        }
        // condicaoPagamentoRepository.CondicaoGet().then(response => {
        //   store.commit('SET_SPLASH_SCREEN', false)
        //   console.log(response.data)
        //   if (response.data.success) {
        //     state.condicoesPagamento = response.data.data
        //   }
        // })
      } catch (error) {
        console.log(error)
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    const buscarDadosAluno = () => {
      store.commit('SET_SPLASH_SCREEN', true)
      alunoRepository
        .AlunoGetById(state.alunoId)
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)

          if (response.data.success) {
            let obj = Object.assign({}, response.data.data)
            obj.birth_date =
              obj.birth_date != null ? obj.birth_date.split('-').reverse().join('/') : ''

            // Use os campos name e surname do backend diretamente
            obj.name = obj.name || ''
            obj.surname = obj.surname || ''

            // Garantir que training_days seja sempre um array
            if (typeof obj.training_days === 'string') {
              try {
                obj.training_days = JSON.parse(obj.training_days)
              } catch (e) {
                obj.training_days = []
              }
            }
            obj.training_days = obj.training_days || []

            obj.active = obj.deleted_at == null
            state.student = obj
            state.cep = state.student.cep
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: 'Erro ao listar dados do aluno!',
            text: error.message,
          })
        })
    }

    // No método salvar, NÃO concatene name e surname.
    // Apenas envie os dois campos separadamente, exatamente como estão no formulário.

    async function salvar() {
      let validated = await validate()
      if (!validated) {
        swal({
          text: 'Preencha todos os campos obrigatórios!',
          icon: 'info',
        })
        return
      }

      // Limpa os campos específicos de "Mensal Por Aula" se não for essa condição
      if (!isMensalPorAula.value) {
        state.student.quantidade_aulas_mes = null
        state.student.training_days = []
      }

      // Limpa o preço por aula se não for "Por Aula"
      if (!isPorAula.value) {
        state.student.price_per_class = null
      }

      // Limpa o valor da consultoria se não for "Consultoria"
      if (!isConsultoria.value) {
        state.student.consulting_price = null
      }

      // Validação: verificar se selecionou a quantidade correta de dias
      if (isMensalPorAula.value && state.student.training_days.length !== diasNecessarios.value) {
        swal({
          text: `Selecione exatamente ${diasNecessarios.value} dias de treino!`,
          icon: 'info',
        })
        return
      }

      let student = Object.assign({}, state.student)

      // Se estiver editando e a senha estiver vazia, remova do objeto para não atualizar
      if (state.alunoId > 0 && (!student.password || student.password === '')) {
        delete student.password
      }

      // Remova qualquer concatenação de name e surname aqui!
      // Apenas envie student.name e student.surname como estão.

      student.birth_date =
        student.birth_date != '' ? student.birth_date.split('/').reverse().join('-') : null
      // student.phone  = this.$filters.justNumbers(state.student.phone)
      // student.cpf  = this.$filters.justNumbers(state.student.cpf)
      store.commit('SET_SPLASH_SCREEN', true)
      if (state.alunoId == 0) {
        alunoRepository
          .AlunoPost(student)
          .then((response) => {
            store.commit('SET_SPLASH_SCREEN', false)
            if (response.data.success) {
              swal({
                title: 'Aluno',
                text: 'Aluno cadastrado com sucesso!',
                icon: 'success',
                customClass: {
                  confirmButton: 'btn bg-gradient-success',
                },
                buttonsStyling: false,
              }).then(() => {
                // Redireciona para a página de alunos e faz um reload completo
                router.push('/alunos').then(() => {
                  window.location.reload() // Realiza o refresh da página
                })
              })
            }
          })
          .catch((error) => {
            store.commit('SET_SPLASH_SCREEN', false)
            // Mostra a mensagem de erro do backend (ex: email duplicado)
            console.log('Erro completo:', error)
            console.log('Response:', error.response)
            console.log('Data:', error.response?.data)

            let errorMessage = 'Erro ao salvar aluno'

            if (error.response && error.response.data) {
              errorMessage = error.response.data.message || error.response.data.error || errorMessage
            } else if (error.message) {
              errorMessage = error.message
            }

            swal({
              icon: 'error',
              title: 'Erro ao salvar aluno',
              text: errorMessage,
            })
          })
      } else {
        alunoRepository
          .AlunoPut(state.alunoId, student)
          .then((response) => {
            store.commit('SET_SPLASH_SCREEN', false)
            if (response.data.success) {
              swal({
                title: 'Aluno',
                text: 'Aluno atualizado com sucesso!',
                icon: 'success',
                customClass: {
                  confirmButton: 'btn bg-gradient-success',
                },
                buttonsStyling: false,
              }).then(() => {
                // Redireciona para a página de alunos e faz um reload completo
                router.push('/alunos').then(() => {
                  window.location.reload() // Realiza o refresh da página
                })
              })
            }
          })
          .catch((error) => {
            store.commit('SET_SPLASH_SCREEN', false)
            // Mostra a mensagem de erro do backend (ex: email duplicado)
            console.log('Erro completo:', error)
            console.log('Response:', error.response)
            console.log('Data:', error.response?.data)

            let errorMessage = 'Erro ao atualizar aluno'

            if (error.response && error.response.data) {
              errorMessage = error.response.data.message || error.response.data.error || errorMessage
            } else if (error.message) {
              errorMessage = error.message
            }

            swal({
              icon: 'error',
              title: 'Erro ao atualizar aluno!',
              text: errorMessage,
            })
          })
      }
    }

    async function validate() {
      const result = await v$.value.$validate()
      console.log(result)
      console.log(v$.value)
      return result
    }

    const formataPeso = () => {
      let v = state.student.weight
      if (/^(?!0{2})\d+(?:,\d+)?$/.exec(v) !== null) {
        if (Number(v.replace(/,/, '.')) <= 800) {
          console.log(v)
        }
      }
      // var numberPattern = '^(0|[1-9]\d*)(,\d+)?$'
      // var res = state.student.weight.match( numberPattern )
      //console.log(res)
      //state.student.weight = parseFloat(res).toFixed(3)
    }

    const rulesMessages = {
      required: helpers.withMessage('Campo obrigatório', required),
    }
    const rules = computed(() => ({
      student: {
        name: { required: rulesMessages.required },
        surname: { required: rulesMessages.required },
        sex: { required: rulesMessages.required },
        height: { required: rulesMessages.required },
        weight: { required: rulesMessages.required },
        email: { required: rulesMessages.required },
        phone: { required: rulesMessages.required },
        // Senha obrigatória apenas ao criar (alunoId === 0), opcional ao editar
        password: {
          required: helpers.withMessage(
            'Campo obrigatório',
            requiredIf(() => state.alunoId === 0)
          )
        },
        payment_condition_id: { required: rulesMessages.required },
        payment_form_id: { required: rulesMessages.required },
        payment_day: { required: rulesMessages.required },
        // Quantidade de aulas só é obrigatória se for "Mensal Por Aula"
        quantidade_aulas_mes: {
          required: helpers.withMessage(
            'Campo obrigatório para Mensal Por Aula',
            requiredIf(() => isMensalPorAula.value)
          )
        },
        // Preço por aula só é obrigatório se for "Por Aula"
        price_per_class: {
          required: helpers.withMessage(
            'Campo obrigatório para Por Aula',
            requiredIf(() => isPorAula.value)
          )
        },
        // Valor da consultoria só é obrigatório se for "Consultoria"
        consulting_price: {
          required: helpers.withMessage(
            'Campo obrigatório para Consultoria',
            requiredIf(() => isConsultoria.value)
          )
        },
      },
    }))

    const v$ = useVuelidate(rules, state)

    return {
      buscaCep,
      state,
      inputNumero,
      salvar,
      v$,
      formataPeso,
      t,
      opcoesAulasMes,
      diasDoMes,
      isMensal,
      isMensalPorAula,
      isPorAula,
      isConsultoria,
      diasSemana,
      diasNecessarios,
      onQuantidadeAulasChange,
      toggleTrainingDay,
    }
  },
}
</script>

<style scoped>
.training-days-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.training-day-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 55px;
  height: 40px;
  padding: 0 12px;
  border: 2px solid #dee2e6;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #fff;
  user-select: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.training-day-checkbox:hover:not(.disabled) {
  border-color: #82d616;
  background-color: #f0fff0;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(130, 214, 22, 0.3);
}

.training-day-checkbox.selected {
  border-color: #82d616;
  background: linear-gradient(135deg, #82d616 0%, #6bc20a 100%);
  color: #fff;
  box-shadow: 0 2px 8px rgba(130, 214, 22, 0.4);
}

.training-day-checkbox.disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background-color: #f5f5f5;
  box-shadow: none;
}

.training-day-checkbox .day-abbrev {
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}
</style>
